import script from "./InfoTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoTable.vue?vue&type=script&lang=ts&setup=true"

import "./InfoTable.vue?vue&type=style&index=0&id=06f31902&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f31902"]])

export default __exports__